import React from 'react';
import PropTypes from 'prop-types';
import { Column, Typography } from '@tempmee/react';

/**
 * One label-over-value stack on the code detail cards — the Figma's
 * "Atom/LabelStack": a small uppercase caption above a light h5 figure.
 *
 * Not `StatTile`: that wraps each figure in its own Card, and the design puts
 * several of these inside one card. Not a `<dl>` either, for the reason
 * CycleSummary gives — Box's `as` accepts only div/span.
 */
export const DetailStat = ({ term, value }) => (
  <Column gap={1} className="min-w-0">
    <Typography variant="caption" uppercase className="text-text-secondary">
      {term}
    </Typography>
    <Typography variant="h5" as="span" className="truncate">
      {value}
    </Typography>
  </Column>
);

DetailStat.propTypes = {
  term: PropTypes.string.isRequired,
  value: PropTypes.node.isRequired,
};

export default DetailStat;
